"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationDetails = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const styles_2 = require("./styles");
const LocationDetails = ({ location, locationNameId, selectedDate }) => {
    const { city, street1, street2, suite, zip, state } = location;
    const streetAddress = (react_1.default.createElement("span", { itemProp: "streetAddress" }, [street1, street2, suite].filter(Boolean).join(', ')));
    const addressLocality = react_1.default.createElement("span", { itemProp: "addressLocality" }, city);
    const addressRegion = react_1.default.createElement("span", { itemProp: "addressRegion" }, state);
    const postalCode = react_1.default.createElement("span", { itemProp: "postalCode" }, zip);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_2.LocationName, { as: selectedDate ? 'h4' : 'h3', id: locationNameId }, location.name),
        react_1.default.createElement(styles_1.LocationAddressRow, null,
            streetAddress,
            ", ",
            addressLocality,
            ", ",
            addressRegion,
            " ",
            postalCode)));
};
exports.LocationDetails = LocationDetails;
//# sourceMappingURL=LocationDetails.js.map